import _ from 'lodash';
import globalStore from '$$globalStore';
import tasksHelpers from '$$store/tasks/helpers';

export default function (instance, ganttData) {
  instance.ganttDataApi.getAllProjectTasksData = () => {
    if (!ganttData) {
      return globalStore.getters['tasksModel/getAllData'];
    }

    return [ganttData.projectTasksData];
  };

  instance.ganttDataApi.getProjectTasksData = projectId => {
    if (!ganttData) {
      return globalStore.getters['tasksModel/getItem'](projectId);
    }

    return ganttData.projectTasksData;
  };

  instance.ganttDataApi.getTasksForGantt = projectId => {
    const projectTasksData = instance.ganttDataApi.getProjectTasksData(projectId);

    if (!projectTasksData) {
      return {
        data: [],
        links: [],
      };
    }

    const tasksData = {
      data: projectTasksData.tasks ? projectTasksData.tasks.map(o => ({ ...o })) : [],
      links: projectTasksData.links ? projectTasksData.links.map(o => ({ ...o })) : [],
    };

    tasksData.data = _.orderBy(tasksData.data, ['parent', 'sortorder', 'id'], ['asc', 'asc', 'asc']);

    tasksData.data = tasksData.data.map(t => {
      if (t.parent === 1) {
        t.parent = 0;
      }
      t.needMultiviewBackground = false;
      t.calendar_id = t.gantt_id;

      if (t.parent === 0) {
        t.open = 1;
      }

      return t;
    }); // needs after correct dates in multiview

    return tasksData;
  };

  instance.ganttDataApi.getDefaultCustomValues = projectId => {
    const projectTasksData = instance.ganttDataApi.getProjectTasksData(projectId);

    return {
      status: projectTasksData.defaultCustomValues.status,
      priority: projectTasksData.defaultCustomValues.priority,
    };
  };

  instance.ganttDataApi.getLinkByGanttId = (projectId, linkId) => {
    const projectTasksData = instance.ganttDataApi.getProjectTasksData(projectId);

    if (!projectTasksData) {
      return {};
    }

    return projectTasksData.links.find(l => +l.id === +linkId) || {};
  };

  instance.ganttDataApi.getTasksDataForBreadcrumbs = (taskId, projectId) => {
    const projectData = instance.ganttDataApi.getProjectTasksData(projectId);
    const preparedTasksMap = _.keyBy(projectData?.tasks, 'id');

    const task = preparedTasksMap[taskId];
    const result = [];

    if (!task) {
      return;
    }

    let parent = task.parent;

    while (parent) {
      const parentData = preparedTasksMap[parent];

      parent = parentData && parentData.parent;
      (parent && parent !== 1) && result.push(parentData);
    }

    return result.reverse();
  };

  instance.ganttDataApi.generateUID = () => tasksHelpers.uid();
}
